"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RowGroup_1 = require("./RowGroup");
exports.default = RowGroup_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Table/components/RowGroup/index.js
// module id = 553
// module chunks = 8